export const IMAGES = {
  login: require('./login.png'),
  logo: require('./Logo.png'),
  logoBlack: require('./logo-black.png'),
  success: require('./success.png'),
  topicPreviewPlaceholder: require('./topic-preview-placeholder.jpg'),
  guestPatterns: require('./guest-patterns.png'),
  samplePattern: require('./sample-pattern.png'),
  profileCover: require('./img-cover.png'),
}
